export const SET_LOAD_PROD_CONTEXT_STATE = 'SET_LOAD_PROD_CONTEXT_STATE';

export default function setLoadProdContext(payload) {
  return {
    type: SET_LOAD_PROD_CONTEXT_STATE,
    payload,
  };
}